"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateActionRequestToJSON = exports.CreateActionRequestFromJSONTyped = exports.CreateActionRequestFromJSON = exports.instanceOfCreateActionRequest = void 0;
var ActionType_1 = require("./ActionType");
/**
 * Check if a given object implements the CreateActionRequest interface.
 */
function instanceOfCreateActionRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "score" in value;
    isInstance = isInstance && "condition" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "strategyId" in value;
    return isInstance;
}
exports.instanceOfCreateActionRequest = instanceOfCreateActionRequest;
function CreateActionRequestFromJSON(json) {
    return CreateActionRequestFromJSONTyped(json, false);
}
exports.CreateActionRequestFromJSON = CreateActionRequestFromJSON;
function CreateActionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'score': json['score'],
        'condition': json['condition'],
        'type': (0, ActionType_1.ActionTypeFromJSON)(json['type']),
        'strategyId': json['strategyId'],
    };
}
exports.CreateActionRequestFromJSONTyped = CreateActionRequestFromJSONTyped;
function CreateActionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'score': value.score,
        'condition': value.condition,
        'type': (0, ActionType_1.ActionTypeToJSON)(value.type),
        'strategyId': value.strategyId,
    };
}
exports.CreateActionRequestToJSON = CreateActionRequestToJSON;
